import React, { useState, Fragment } from 'react';

import MultipleProdutsSlots from '../modals/MultipleProductsSlots';
import icons from './../../../icons.svg';

const CabinetPlanogram = ({ t, planogramData, cabinet, allProducts }) => {
  const [imageStackingModal, setImageStackingModal] = useState({
    open: false,
    slotData: {},
    shelfNumber: null,
  });

  return (
    <Fragment>
      <MultipleProdutsSlots
        isOpen={imageStackingModal.open}
        close={() => {
          setImageStackingModal({
            open: false,
            slotData: {},
            shelfNumber: null,
          });
        }}
        cabinetSlotData={imageStackingModal.slotData}
        shelfNumber={imageStackingModal.shelfNumber}
        allProducts={allProducts}
        t={t}
        cabinet={cabinet}
      />
      <label className="replenish-plan__label">
        {t('common:planogramHelpText')}
      </label>
      <div className="planogram__cabinet">
        {/**
         * <div className="planogram__cabinet-screen">{t('common:screen')}</div>
         */}

        <div className="planogram__cabinet-shelves">
          {(() => {
            const allShelves = [];
            // for each shelf data, draw shelf in the planogram
            for (let i = 1; i < planogramData.shelvesCount + 1; i++) {
              allShelves.push(
                <div className="planogram__cabinet-shelf" key={`shelf-${i}`}>
                  <div className="planogram__slots">
                    {(() => {
                      // for each slot in the shelf, draw slot in the planogram
                      const allSlots = [];
                      const shelf = planogramData.shelves.find(
                        shelf => shelf.shelf === i
                      );

                      for (let j = 1; j < shelf.slots.length + 1; j++) {
                        if (!shelf.slots.length) {
                          allSlots.push(
                            <div
                              className="planogram__slots-item"
                              key={`shelf-${j}`}
                            >
                              {j}
                            </div>
                          );
                        } else {
                          const selectedSlot = shelf.slots.find(
                            productSlot => productSlot.slot === j
                          );
                          if (
                            !selectedSlot ||
                            (selectedSlot && !selectedSlot.products.length)
                          ) {
                            allSlots.push(
                              <div
                                className="planogram__slots-item"
                                key={`slot-${i}-${j}`}
                              >
                                {j}
                              </div>
                            );
                          } else {
                            //only one product in the a slot
                            if (selectedSlot.products.length === 1) {
                              const selectedProduct = allProducts.find(
                                product =>
                                  product.id === selectedSlot.products[0]
                              );
                              allSlots.push(
                                <div
                                  className="planogram__slots-item"
                                  title={selectedProduct.name}
                                  key={`slot-${i}-${j}-${selectedProduct.id}`}
                                  onClick={() =>
                                    setImageStackingModal({
                                      open: true,
                                      slotData: selectedSlot,
                                      shelfNumber: i,
                                    })
                                  }
                                >
                                  {selectedProduct.imageUrl ? (
                                    <img
                                      src={selectedProduct.imageUrl}
                                      alt="product"
                                    />
                                  ) : (
                                    <svg className="planogram__slots-item-cube">
                                      <use
                                        xlinkHref={`${icons}#icon-cube`}
                                      ></use>
                                    </svg>
                                  )}
                                </div>
                              );
                            } else {
                              //mulitple products in the slot, show only the last added
                              //show stack icon
                              const lastAddedBarcode =
                                selectedSlot.products[
                                  selectedSlot.products.length - 1
                                ];
                              const selectedProduct = allProducts.find(
                                product => product.id === lastAddedBarcode
                              );
                              selectedProduct &&
                                allSlots.push(
                                  <div
                                    className="planogram__slots-item planogram__slots-item--stack"
                                    key={`slot-${i}-${j}-${lastAddedBarcode}`}
                                    onClick={() =>
                                      setImageStackingModal({
                                        open: true,
                                        slotData: selectedSlot,
                                        shelfNumber: i,
                                      })
                                    }
                                  >
                                    {selectedProduct.imageUrl ? (
                                      <img
                                        src={selectedProduct.imageUrl}
                                        alt="product"
                                      />
                                    ) : (
                                      <svg className="planogram__slots-item-cube">
                                        <use
                                          xlinkHref={`${icons}#icon-cube`}
                                        ></use>
                                      </svg>
                                    )}

                                    <svg className="planogram__slots-item-stack">
                                      <use
                                        xlinkHref={`${icons}#icon-stack`}
                                      ></use>
                                    </svg>
                                  </div>
                                );
                            }
                          }
                        }
                      }
                      return allSlots;
                    })()}
                  </div>
                </div>
              );
            }
            return allShelves;
          })()}
        </div>
      </div>
    </Fragment>
  );
};

export default CabinetPlanogram;
